import { success, failure, request } from 'app/actions';
import * as actions from './reportApplicationActions';
import * as helpers from './reportApplicationHelpers';

const initialState = {
  evaluations: [],
  years: [],
  currentYear: [],
  groups: [],
  contracts: [],
  filterReports: [],
  criteria: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case request(actions.GET_EVALUATION_CRITERIA):
    case failure(actions.GET_EVALUATION_CRITERIA):
      return {
        ...state,
        criteria: initialState.criteria,
      };
    case success(actions.GET_EVALUATION_CRITERIA):
      return {
        ...state,
        criteria: action.payload.content,
      };
    case success(actions.GET_GROUPS):
      return {
        ...state,
        groups: action.payload.content,
        contracts: helpers.getContracts(action.payload.content),
      };
    case success(actions.GET_EVALUATIONS):
      return {
        ...state,
        evaluations: helpers.getEvaluations(action.payload.content),
        years: helpers.getYears(action.payload.content),
        currentYear: helpers.getCurrentYear(action.payload.content),
      };
    case failure(actions.GET_FILTERS_REPORTS):
      return {
        ...state,
        filterReports: initialState.filterReports,
      };
    case success(actions.GET_FILTERS_REPORTS):
      return {
        ...state,
        filterReports: action.payload.content,
      };
    default:
      return state;
  }
};

export default reducer;
